import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

import styles from "./DimensionalAssistantModal.module.css";

import DraggableModalWrapper from "@/components/shared/ModalWrapper/DraggableModalWrapper/DraggableModalWrapper";
import { GoDeeperIconLarge } from "../GoDeeperIcon";
import { useGetInsightPower } from "../useGetInsightPower";
import {
  dimensionData,
  dimensionIcons,
} from "@/assets/traitInfo/dimensionData";
import ConsumableBoxes from "./ConsumableBoxes/ConsumableBoxes";
import { Mixpanel } from "@/helpers/mixpanel";
import { useAuth } from "@/context/AuthContext";

export default function ConsumableBoxesModal(props: { onClose: () => void }) {
  const { user } = useAuth();

  const numberOfMessagesRemaining = useSelector(
    (state: RootState) => state.chatbot
  ).numberOfMessagesRemaining;

  const { power, finishedSlugs } = useGetInsightPower();

  useEffect(() => {
    Mixpanel?.people.update({ "Chatbot | insight power": power }, user?.uid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [power]);

  const messageRemainingText =
    numberOfMessagesRemaining === "unlimited" ? (
      <p className={styles.messageRemainingText}>
        Unlimited messages with <span className={styles.plusText}>Plus</span>
      </p>
    ) : numberOfMessagesRemaining === 0 ? (
      <p className={styles.messageRemainingText}>
        {"You're out of messages. Get more:"}
      </p>
    ) : (
      <p className={styles.messageRemainingText}>
        {numberOfMessagesRemaining} messages remaining
      </p>
    );

  const mappedDimensions = dimensionData
    .sort((a, b) => {
      const aFinished = finishedSlugs.includes(a.slug);
      const bFinished = finishedSlugs.includes(b.slug);

      if (aFinished && !bFinished) return -1;
      if (!aFinished && bFinished) return 1;
      return 0;
    })
    .map((d) => {
      const finished = finishedSlugs.includes(d.slug);
      if (finished) {
        return (
          <div className={styles.dimensionIcon} key={d.slug}>
            {dimensionIcons[d.slug].icon}
          </div>
        );
      }
      return (
        <div className={styles.dimensionIcon} key={d.slug}>
          {dimensionIcons[d.slug].iconInactive}
        </div>
      );
    });

  return (
    <DraggableModalWrapper
      onClose={() => {
        props.onClose();
      }}
      backgroundColor="#181716"
    >
      <main className={styles.main}>
        <h1 className={styles.title}>Dimensional Assistant</h1>
        <div className={styles.iconDiv}>
          <GoDeeperIconLarge full={numberOfMessagesRemaining !== 0} />
        </div>

        {messageRemainingText}

        <div className={styles.consumablesMapper}>
          <ConsumableBoxes />
        </div>

        <div className={styles.buttonDiv}>
          <button className={styles.closeBtn} onClick={() => props.onClose()}>
            Close
          </button>
        </div>
      </main>
    </DraggableModalWrapper>
  );
}
